import axios from "axios";
// See .env for sandbox / prod / client change.
const HTTP = axios.create({
  baseURL: process.env.VUE_APP_BETTEREZ_BASE_URL + "/inventory/",
  headers: {
    "x-api-key": process.env.VUE_APP_BETTEREZ_X_API_KEY,
  },
});

export default {
  getProducts() {
    return HTTP.get("products", {
      params: {
        channels: "websales",
        //hasPassengerInfo: true,
        enabled: true,
      },
    });
  },
  getFares(productId) {
    return HTTP.get("fares", {
      params: {
        productIds: productId,
        channels: "websales",
        enabled: true,
      },
    });
  },
  getStations(productId) {
    return HTTP.get("stations", {
      params: {
        productId: productId,
        enabled: true,
      },
    });
  },
  getDestinationStations(productId, departure) {
    return HTTP.get("stations", {
      params: {
        productId: productId,
        departure: departure,
        enabled: true,
      },
    });
  },
  getTrips(
    productId,
    originId,
    destinationId,
    departureDate,
    returnDate,
    fareIds
  ) {
    return HTTP.get("trips", {
      params: {
        productId: productId,
        originId: originId,
        destinationId: destinationId,
        departureDate: departureDate,
        returnDate: returnDate,
        fareIds: fareIds,
      },
    });
  },
  getOperationMessages(providerId, dateFrom, dateTo) {
    let dateFromObj = new Date(dateFrom);
    let dateToObj = dateTo ? new Date(dateTo) : new Date(dateFrom);
    
    //dateToObj.setDate(dateToObj.getDate() + 1);
    return HTTP.get("operation-messages/", {
      // https://api.betterez.com/inventory/operation-messages/?avoidPagination=true&effectiveDateTimeStartBefore=2020-08-31T03%3A00%3A00.000Z&effectiveDateTimeEndAfter=2020-09-01T02%3A59%3A59.000Z&active=true&providerId=570e4206d12bb17e0b0015fe&x-api-key=01ae8591-1a38-4514-b49b-6c970b1847f3
      // https://api.betterez.com/inventory/operation-messages/?avoidPagination=true&effectiveDateTimeStartBefore=2020-08-31T00%253A00%253A000Z&effectiveDateTimeEndAfter=2020-08-31T00%253A00%253A000Z&active=true&providerId=570e4206d12bb17e0b0015fe&x-api-key=01ae8591-1a38-4514-b49b-6c970b1847f3
      params: {
        avoidPagination: true,
        effectiveDateTimeStartBefore: dateToObj.toISOString(),
        effectiveDateTimeEndAfter: dateFromObj.toISOString(),
        active: true,
        providerId: providerId,
        //stationId: stationId,
      },
    });
  },
  getTrip(tripId) {
    return HTTP.get("trip/" + tripId);
  },
  getSSRS(productId) {
    return HTTP.get("ssrs", {
      params: {
        productId: productId,
      },
    });
  },
  getSeatMap(
    seatMapId,
    routeId,
    scheduleId,
    manifestDate,
    originId,
    destinationId,
    providerId,
    legFromIndex,
    legToIndex
  ) {
    return HTTP.get(
      "seatmaps/" +
        seatMapId +
        "/available-seats/" +
        routeId +
        "/" +
        scheduleId +
        "/" +
        manifestDate,
      {
        params: {
          originId: originId,
          destinationId: destinationId,
          providerId: providerId,
          legFromIndex: legFromIndex,
          legToIndex: legToIndex,
          channel: "websales",
        },
      }
    );
  },
  getCountries() {
    return HTTP.get("countries");
  },
};
